import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const behaviorSignals = [
  { label: 'Usage drops', tone: 'text-orange' },
  { label: 'Usage spikes', tone: 'text-accent' },
  { label: 'Engagement shifts', tone: 'text-green' },
];

export default function HiddenRiskSection() {
  return (
    <section className="py-24 px-6 border-t border-light">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <LandingReveal>
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            Real churn risk is hard to separate from{' '}
            <span className="text-orange">normal customer behavior</span>.
          </h2>
          <div className="space-y-5 landing-prose">
            <p>Across hundreds of accounts, customer behavior is constantly changing.</p>
            <div className="flex flex-wrap gap-3 py-2">
              {behaviorSignals.map((signal) => (
                <span
                  key={signal.label}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium border border-medium bg-surface-subtle ${signal.tone}`}
                >
                  {signal.label}
                </span>
              ))}
            </div>
            <p>Sometimes it means nothing. Sometimes it&apos;s the beginning of churn.</p>
            <p>
              And when your CS team is responsible for hundreds of customers, you can&apos;t investigate every change
              deeply enough to know which is which.
            </p>
            <p className="text-primary font-medium border-l-2 border-accent pl-4">
              Real risk can stay hidden until the customer makes it obvious. And by then, your team has a lot less room
              to change the outcome.
            </p>
          </div>
        </LandingReveal>

        <LandingReveal delayClass="landing-delay-1" className="landing-card p-2 overflow-hidden">
          <img
            src="/images/audience1.png"
            alt="Audience risk distribution across customer accounts"
            className="w-full rounded-lg object-contain"
          />
        </LandingReveal>
      </div>
    </section>
  );
}
